import { ComponentStyles } from "types/common";

const styles: ComponentStyles = {
  container: {
    display: "flex",
    flexDirection: {
      xs: "column-reverse",
      md: "row",
    },
    alignItems: {
      xs: "start",
      md: "center",
    },
    height: "100%",
  },
  cardContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    gap: 4,
    alignItems: "center",
  },
};

export default styles;
